onReady(() => {
  $(document).foundation();
  $(".off-canvas").css("display", "");

  /* Sticky Header Function */
  const watchStickyHeader = () => {
    const header_parent = $("header#header");
    const sticky = $(".header__inner"),
      scroll = $(window).scrollTop();

    if (scroll >= 100) {
      sticky.addClass("is-sticky");
      header_parent.addClass("header--sticky");
    }
    else {
      sticky.removeClass("is-sticky");
      header_parent.removeClass("header--sticky");
    }
  };
  watchStickyHeader();
  $(window).scroll(watchStickyHeader);

  //Initialize Header and Footer
  $("header.header").addClass("is-loaded");
  $("footer.footer").addClass("is-loaded");

  //Quicklink
  quicklink.listen({
    ignores: [
      (uri) => {
        return (
          !uri.includes("/pages") &&
          !uri.includes("/blogs") &&
          !uri.includes("/products") &&
          !uri.includes("/collections")
        );
      },
    ],
  });

  if ($(".header__currency-switcher").length) {
    new Promise((res, rej) => {
      const interval = setInterval(() => {
        if ($(".pick_currency.mldesk").length) {
          clearInterval(interval);
          res();
        }
      }, 100);
    }).then(() => {
      $(".pick_currency.mldesk").appendTo($(".header__currency-switcher"));
    });
  }

  //Lozad
  $("img.lozad").each((i, e) => {
    $(e)
      .attr("data-src", $(e).attr("src"))
      .attr("data-srcset", $(e).attr("srcset"));
    $(e)
      .removeAttr("srcset")
      .removeAttr("loading")
      .attr(
        "src",
        "data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%271206%27%20height%3D%271387%27%20style%3D%27background%3Atransparent%27%2F%3E"
      );
  });

  const lozadObserver = lozad("img.lozad").observe();

  // Fade In Animation
  // Create the intersection observer
  let observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        $(entry.target).addClass("fade-in");
        observer.unobserve(entry.target); // Optionally stop observing once faded in
      }
    });
  });

  // Select all elements with [data-inview="fade-in"]
  $('[data-inview="fade-in"]').each(function () {
    observer.observe(this);
  });
}, true);